import styled from 'styled-components';

import {
  BuildingApartment,
  Cake,
  EnvelopeSimple,
  MapPinArea,
  Phone,
  UserCircleGear,
  UserList,
} from '@phosphor-icons/react';
import { Stack } from '@mui/system';

import { Card, DescriptionTable, UserAvatar } from '../../../components';
import { IUser } from '@shared/types';

const StyledUserCard = styled.div`
  border-bottom: 1px solid #d5d9e2;
  padding-bottom: 10px;
`;

interface IUserInfo {
  data: IUser;
}

export const UserCard = ({ data }: IUserInfo) => {
  const { username, name, email, address, gender, avatar, role } = data;
  return (
    <Card
      options={{ isCollapsible: true, $cardBodyPadding: '0.75rem' }}
      title={
        <Stack flexDirection='row' alignItems='center' gap={1} padding={1}>
          <UserList />
          Personal Profile
        </Stack>
      }
    >
      <StyledUserCard>
        <UserAvatar avatar={avatar} gender={gender} name={name} username={username} />
      </StyledUserCard>
      <DescriptionTable
        dataSource={[
          { labelIcon: <UserCircleGear />, label: 'Role', value: role },
          { labelIcon: <EnvelopeSimple />, label: 'Email', value: email },
          { labelIcon: <Phone />, label: 'Phone', value: '' },
          { labelIcon: <Cake />, label: 'Date of Birth', value: '' },
          { labelIcon: <MapPinArea />, label: 'Address', value: address },
          { labelIcon: <BuildingApartment />, label: 'School', value: '' },
        ]}
      />
    </Card>
  );
};
